// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__7Z775","spinner":"Spinner_spinner__Hy2t-","spinner-aib1d7":"Spinner_spinner-aib1d7__U1wZo"};